<template>
  <td>
    <slot></slot>
  </td>
</template>

<script>
export default {
    name:'qb-td'
}
</script>

<style>
</style>